export default "__VITE_ASSET__IshfM6te__"